import { createRoot } from 'react-dom/client'
import Root from './Root.tsx'
import * as Sentry from '@sentry/react'
import { IS_PRODUCTION, SENTRY_DSN } from 'constants/env.ts'
import { TO_IGNORE_ERRORS } from 'constants/logging.ts'

Sentry.init({
  dsn: SENTRY_DSN,
  environment: IS_PRODUCTION ? 'production' : 'staging',
  enableLogs: IS_PRODUCTION,
  tracesSampleRate: IS_PRODUCTION ? 0.1 : 1,
  normalizeDepth: 10,
  ignoreErrors: TO_IGNORE_ERRORS,
  // Ignore errors originating from extensions
  denyUrls: [/extensions\//i, /^chrome-extension:\/\//i, /^moz-extension:\/\//i]
})

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<Root />)
